import { FC, PropsWithChildren } from "react";
import { Badge, Collapsible, Flex, useDisclosure } from "@chakra-ui/react";

import { ChevronDownIcon, ChevronUpIcon } from "@shared/components/Icons";

interface CaseResultSectionProps {
  title: string;
}

const CaseResultSection: FC<PropsWithChildren<CaseResultSectionProps>> = ({ title, children }) => {
  const { open, onToggle } = useDisclosure({ defaultOpen: true });
  return (
    <Flex flexDirection="column" w="full">
      <Flex justifyContent="space-between">
        <Badge variant="subtle" mb={open ? 5 : 0}>
          {title}
        </Badge>
        {open ? (
          <ChevronUpIcon boxSize={6} color="brand.primary" onClick={onToggle} cursor="pointer" />
        ) : (
          <ChevronDownIcon boxSize={6} color="brand.primary" onClick={onToggle} cursor="pointer" />
        )}
      </Flex>
      <Collapsible.Root open={open} w="full">
        <Collapsible.Content>{children}</Collapsible.Content>
      </Collapsible.Root>
    </Flex>
  );
};

export default CaseResultSection;
